<div class="sidenav-content card-items " @routeAnimation>
	<div class="card-title-block-non-sticky">
		<copo-back-button></copo-back-button>
		<div class="card-title-label" translate>organization.card.organizationcard</div>
		<div class="card-title-label">{{ organization?.name?.toUpperCase() }}</div>
	</div>
	<div class="copo-filter-block">
		<a mat-flat-button [class.copo-button-selection-selected]="this.isActivate('details')"
			[color]="this.isActivate('details') ? 'primary' : undefined"
			class="copo-button-selection copo-button-selection-margin"
			[routerLink]="['/user/organization', organization?.id, 'details']"
			[replaceUrl]="true">
			<span translate>organization.card.details</span>
		</a>
		<a mat-flat-button [class.copo-button-selection-selected]="this.isActivate('informational-visibilities')"
			[color]="this.isActivate('informational-visibilities') ? 'primary' : undefined"
			class="copo-button-selection copo-button-selection-margin"
			[routerLink]="['/user/organization',organization?.id,'informational-visibilities']"
			[replaceUrl]="true"
			*ngIf="organization?.id !== -1">
			<span translate>settings.informational-visibilities</span>
		</a>
		<a mat-flat-button [class.copo-button-selection-selected]="this.isActivate('transactional-visibilities')"
			[color]="this.isActivate('transactional-visibilities') ? 'primary' : undefined"
			class="copo-button-selection copo-button-selection-margin"
			[routerLink]="['/user/organization',organization?.id,'transactional-visibilities']"
			[replaceUrl]="true"
			*ngIf="organization?.id !== -1">
			<span translate>organization.card.transactional-visibilities</span>
		</a>
		<a mat-flat-button [class.copo-button-selection-selected]="this.isActivate('services') || this.isActivate('/manage-service')"
			[color]="this.isActivate('services') || this.isActivate('/manage-service') ? 'primary' : undefined"
			class="copo-button-selection copo-button-selection-margin"
			[routerLink]="['/user/organization',organization?.id,'services']"
			[replaceUrl]="true">
			<span translate>organization.card.services</span>
		</a>
		<a mat-flat-button [class.copo-button-selection-selected]="this.isActivate('users')"
			[color]="this.isActivate('users') ? 'primary' : undefined"
			class="copo-button-selection copo-button-selection-margin"
			[routerLink]="['/user/organization',organization?.id,'users']"
			[replaceUrl]="true">
			<span translate>organization.card.users</span>
		</a>
	</div>
	<router-outlet></router-outlet>
</div>